import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './productRail.css';

/* ProductRail — "You might also like", SP-main product.html's `related()`:
   `SF.railHead(...)` + `SF.railWrap(cards)`, a heading row with a trailing link
   over a horizontally scrolling row of the shared product card.

   Six, not eight (the reference's own cap, 2026-09-11): this is the bottom of a
   product page, not a shelf to browse.

   No scroll arrows: the reference draws two and then measures the row to hide
   them when everything fits, but its arrows are wired by a shell this app does
   not have, and a button that scrolls a container the shopper can already swipe
   is the least valuable half of the pattern. ⛔ Arrows added later must carry the
   reference's `has-arrows` measurement, or the heading reserves 88px beside
   nothing (storefront.css:369).

   The section renders nothing with nothing in it, as `related()` does. */
export default function ProductRail({ title, seeAllLabel, seeAllHref, items, renderItem }) {
  if (!items?.length) return null;

  return (
    <section className="pr-sec" aria-labelledby="pr-head">
      <div className="pr-in">
        <div className="pr-sh">
          <div><h2 id="pr-head">{title}</h2></div>
          {seeAllLabel && seeAllHref && (
            <Link className="sf-seeall" to={seeAllHref}>{seeAllLabel} &rarr;</Link>
          )}
        </div>

        <div className="pr-railwrap">
          <div className="pr-rail">
            {items.map(renderItem)}
          </div>
        </div>
      </div>
    </section>
  );
}

ProductRail.propTypes = {
  title: PropTypes.string.isRequired,
  seeAllLabel: PropTypes.string,
  seeAllHref: PropTypes.string,
  /** Already ranked and capped by the caller. */
  items: PropTypes.array,
  /** `(item, index) => node` — a `ProductCard`, so the page owns the links. */
  renderItem: PropTypes.func.isRequired,
};

ProductRail.defaultProps = { items: [] };
